import React, { useDebugValue, useEffect, useState } from "react";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  InputGroup,
  InputGroupText,
  
  Input,
  Button,
  Spinner,
  Badge,
} from "reactstrap";
import { MdModeEdit, MdDelete } from "react-icons/md";
// import { HiEye } from "react-icons/hi";
import { toast } from "react-toastify";
import ApiClient from "../../api-client";
import Swal from 'sweetalert2';
import { useDispatch } from "react-redux";
import { formatedDate } from "utils/common";

function EscrowRequestList() {
  const [escrowRequest, setEscrowRequestData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [showDeleteAlert, setShowAlert] = useState(false);
  const [transactionId, setSelectedTransactionId] = useState(null);
  const [counting, setCounting] = useState([]);
  const pageSize = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [confirmBtnText, setConfirmBtnText] = useState("Yes, release fund!");

  const fetchEscrowRequest = async (pageNumber = currentPage, query = "") => {
    try {
      setLoader(true);
      const getAllRequest = await ApiClient.get(
        `api/payment/get-escrow-request?page=${pageNumber}&limit=${pageSize}&searchText=${query}`,
        "",
        true,
        dispatch
      );
      setEscrowRequestData(getAllRequest.body.result);
      setCounting(getAllRequest.body);
      setLoader(false);
    } catch (error) {
      toast.error(error.message, { autoClose: 3000 });
      setLoader(false);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    fetchEscrowRequest(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleReleaseFund = (id) => {
    setSelectedTransactionId(id);
    setShowAlert(true);
  };

  const confirmReleaseFund = async () => {
    try {
      setConfirmBtnText('Loading...')
      const releaseFund = await ApiClient.post(
        `api/payment/release-fund`,
        { transactionId: transactionId },
        true,
        dispatch
      );
      if (releaseFund.status === true) {
        toast.success(releaseFund.message, { autoClose: 1000 });
        setLoader(false);
        setShowAlert(false);
        fetchEscrowRequest(currentPage, searchQuery);
        setConfirmBtnText("Yes, release fund!")
      }
    } catch (error) {
      setLoader(false);
      toast.error(error.message, { autoClose: 1000 });
      setShowAlert(false);
      setConfirmBtnText("Yes, release fund!")
    }
  };

  return (
    <>
      <div className="content">
      <div className="content-headline d-flex justify-content-between">
        <h4>Escrow Request</h4>
      </div>
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="8"></Col>
                  <Col md="4">
                    <form>
                      <InputGroup className="no-border">
                        <Input
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                          <InputGroupText>
                            <i className="nc-icon nc-zoom-split" />
                          </InputGroupText>
                      </InputGroup>
                    </form>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                {loader && (
                  <span className="table-loader">
                    <Spinner color="primary">Loading...</Spinner>
                  </span>
                )}
                {!loader && (
                  <>
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>Transaction ID</th>
                          <th>Provider Name </th>
                          <th>Customer Name</th>
                          <th>Total Amount</th>
                          <th>Payment Status</th>
                          <th>Created Date</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {escrowRequest?.map((request) => (
                          <tr key={request._id}>
                            <td>{request?.transactionId}</td>
                            <td>{request?.providerFullName}</td>
                            <td>{request?.customerFullName}</td>
                            <td>R {request?.totalAmount}</td>
                            <td>{request?.status}</td>
                            <td>{formatedDate(request?.createdAt)}</td>
                            <td className="text-center">
                            {(request.isReleased == false ? 
                               <Button
                               onClick={() => handleReleaseFund(request.transactionId)}
                               className="common-button"
                             >
                               Release Fund
                             </Button> : ""
                             )}
                             
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <div className="pagination d-flex justify-content-center align-items-center">
                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                        className="common-button"
                      >
                        Previous
                      </Button>
                      <span className="mx-3">
                        Page {counting?.currentPage} of {counting?.totalPages}
                      </span>
                      <span className="mx-3">
                        <strong>Total records: </strong>
                        {counting?.totalRecords}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === counting?.totalPages}
                        className="common-button"
                      >
                        Next
                      </Button>
                    </div>
                  </>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {showDeleteAlert && (
        <Swal
          info
          showCancel
          confirmBtnText={confirmBtnText}
          confirmBtnBsStyle="info"
          title="Are you sure?"
          onConfirm={confirmReleaseFund}
          onCancel={() => setShowAlert(false)}
          focusCancelBtn
          style={{width: '36em'}}
        >
          You will not be able to revert this transaction!
        </Swal>
      )}
    </>
  );
}

export default EscrowRequestList;
